module.exports = __webpack_public_path__ + "img/fg.2f688e9.png";